var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "photos-carousel" },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigation,
              expression: "showNavigation"
            }
          ],
          staticClass: "button-prev",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.prevSlide()
            }
          }
        },
        [_c("i", { staticClass: "icon-arrow-bold-left icon-lg" })]
      ),
      _vm._v(" "),
      _c(
        "swiper",
        { ref: "swiper", attrs: { options: _vm.swiperOptions } },
        _vm._l(_vm.slides, function(slide, index) {
          return _c("swiper-slide", { key: index }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "fancy-box",
                    rawName: "v-fancy-box:photos",
                    arg: "photos"
                  }
                ],
                attrs: { href: slide.src }
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: slide.thumbs["100x100"], alt: slide }
                })
              ]
            )
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigation,
              expression: "showNavigation"
            }
          ],
          staticClass: "button-next",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.nextSlide()
            }
          }
        },
        [_c("i", { staticClass: "icon-arrow-bold-right icon-lg" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }